export default {
  date: 'June 14, 2024',
  title: 'What changes can be made to the Getfloorplan layouts?',
  description: 'After processing, we can manually adjust the floor plan as needed',
  id: 'layouts-changes',
  jsx: () => (
    <div class='novelty__text'>
      <p>After processing, we can manually adjust the floor plan as needed</p>
      <p>We can make the following changes to your project:</p>
      <ul>
        <li>Add, move, or remove furniture.</li>
        <li>Add or remove walls.</li>
        <li>Add, move, or remove windows and doors.</li>
        <li>Change the size of rooms.</li>
      </ul>
      <p>
        Additionally, we can work with you to create a custom style that meets your needs.
        <br></br>
        For example: customize color schemes, develop textures, and add textile elements.
      </p>
      <p>Moreover, we can create an entirely new style with different furniture, interior elements, textures, and textiles.</p>
      <p>
        For more information about our services or to discuss your specific needs, contact us at
        <a href='mailto:support@getfloorplan.com'> support@getfloorplan.com</a>. We are here to ensure your floor plan looks exactly how you want it to!
      </p>
    </div>
  ),
  thumb: 'news/21.webp',
};
